"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const { AkNavigationItemGroup, SkeletonContainerItem } = require("@atlaskit/navigation");
const styled_components_1 = __importDefault(require("styled-components"));
const platform_restriction_1 = require("../platform/platform-restriction");
const SkeletonNavigationItems = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
class PlatformRestrictedNavGroup extends React.Component {
    render() {
        const { id, platform, title, children, numberOfSkeletonLinks } = this.props;
        const numberOfItems = numberOfSkeletonLinks || (Array.isArray(children) ? children.length : 1);
        return (React.createElement(platform_restriction_1.PlatformRestriction, { id: id, shouldRender: servicePlatform => servicePlatform === platform, loadingContent: React.createElement(AkNavigationItemGroup, { title: title },
                React.createElement(SkeletonNavigationItems, null, new Array(numberOfItems).fill(undefined).map((_, index) => (React.createElement(SkeletonContainerItem, { key: index }))))) },
            React.createElement(AkNavigationItemGroup, { title: title }, children)));
    }
}
exports.PlatformRestrictedNavGroup = PlatformRestrictedNavGroup;
